import React from 'react'

import ButtonDeprecated from "../../../../gd-components/buttons/gd-button/gd-button"
import {Feature} from "../../../../gd/access-control/feature-access/const"
import Project from "../../../../model2/project/project"

type Props = {
    project     : Project

    onClickNew  : func
}

export default function AddCustomField(props: Props) {

    const company       = gd.session.companies.get(gd.companyId)
    const showNewButton = props.project ? gd.ac.check.canCreateCustomFields(props.project.id) : true

    if (!showNewButton) {
        return null
    }

    if (company.license.customFields) {
        return (
            <div className="row cf new-field">
                <div className="element">
                    <ButtonDeprecated
                        type    = "blue"
                        size    = "small"
                        label   = "+ New Custom Field"
                        onClick = {props.onClickNew}
                    />
                </div>
                <div className="cf"/>
            </div>
        );
    } else {
        return (
            <div className="row cf new-field">
                <div className="element">
                    <ButtonDeprecated
                        type    = "gray"
                        size    = "small"
                        label   = "+ New Custom Field"
                        onClick = {()=>{gd.modals.other.upgradeToPro(Feature.CUSTOM_FIELDS)}}

                    />
                    <span className="i5-pro"/>
                </div>
                <div className="cf"/>
            </div>
        )
    }
}